<b class="mb-0">
    <ng-content></ng-content>
</b>
